import React from "react";
import { AppBar, Toolbar, Typography, Box, IconButton } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Logout from "@mui/icons-material/Logout";
import logo from "../components/images/kineticlogo1.png";

const Header: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("decodedToken");
    navigate("/login");
  };

  return (
    <Box>
      {/* Header Section */}
      <AppBar position="static" style={{ backgroundColor: "black" }}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Logo Section */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src={logo}
              alt="Logo"
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
            />
            <Typography variant="h6" sx={{ color: "white", marginLeft: 1 }}>
              Kinetic
            </Typography>
          </Box>
          {/* Profile and Logout Icons */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton edge="end" color="inherit">
              <AccountCircle sx={{ marginRight: "10px" }} />
            </IconButton>
            <IconButton edge="end" color="inherit" onClick={handleLogout}>
              <Logout />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ height: "100vh", background: "#1a1a1a" }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Header;
